import { render, staticRenderFns } from "./ModalCombineSpaces.vue?vue&type=template&id=2f75fcbf"
import script from "./ModalCombineSpaces.vue?vue&type=script&lang=js"
export * from "./ModalCombineSpaces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports